import Vue from 'vue'
import VueRouter from 'vue-router'
import SingleSearch from "@/views/SingleSearch.vue";
import DetailForSite from "@/views/DetailForSite.vue";
import batchSearch from "@/views/BatchSearch.vue";
import HomePage from "@/views/HomePage.vue";
import signatureDB from "@/views/SignatureDB.vue";
import Browse from "@/unUsedComponents/Browse.vue";
import Download from "@/views/Download.vue";
import statistics from "@/views/Statistics.vue";
import Signature from "@/views/Signature.vue";
import store from "@/store";

Vue.use(VueRouter)

import {EventBus} from "@/utils/event-bus";


const routes = [{
  path: '/',
  name: 'Home',
  component: HomePage
},
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/single-search',
    name: 'SingleSearch',
    component: SingleSearch,
    beforeEnter: (to, from,next) => {
      store.state.currtab=2;
      next();
    },
    meta:{
      keepAlive: true
    }
  },
  {path:"/batch-search",
  name:'batchSearch',
  component: batchSearch,
    beforeEnter: (to, from,next) => {
      store.state.currtab=2;
      next();
    },
  },
  {
    path: '/downloads',
    name: 'Download',
    component: Download
  },{
    path: '/signature',
    name: 'Signature',
    component: Signature
  },
  {
    path: '/signaturedb',
    name: 'SignatureDB',
    component: signatureDB
  },
  {
    path: '/doc',
    name: 'doc',
    beforeEnter: (to, from) => {
      // window.open("/ptmatlas/docs/#/", "_blank");
      // return false;
    },
  },
  {path:'/statistics',
    name:'statistics',
    component: statistics},
  {
    path:"/single-search/:id",
    component: DetailForSite,
    props: true
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes
})

// router/index.js
router.afterEach((to, from) => {
  if (to.name === 'SingleSearch') {
    EventBus.$emit('update-tab', 'Search');
  } else if (to.name === 'Home') {
    EventBus.$emit('update-tab', 'Home');
  }
});

export default router
